module.exports = __webpack_public_path__ + "img/customer02.bf5900f.png";